import React, { useState } from "react";
import { format, parse, isValid } from "date-fns";
import { fr } from "date-fns/locale";
import { CalendarDays, X } from "lucide-react";
import { Calendar } from "./ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import { Input } from "./ui/input";
import { Button } from "./ui/button";

const isoToDate = (iso) => {
  if (!iso) return undefined;
  const d = parse(iso.slice(0, 10), "yyyy-MM-dd", new Date());
  return isValid(d) ? d : undefined;
};
const isoToFr = (iso) => { const d = isoToDate(iso); return d ? format(d, "dd/MM/yyyy") : ""; };

/** Champ date français : saisie jj/mm/aaaa + calendrier fr-FR. value/onChange en ISO yyyy-mm-dd. */
export const DatePickerFr = ({ value, onChange, required, placeholder = "jj/mm/aaaa", "data-testid": testId, className = "" }) => {
  const [text, setText] = useState(isoToFr(value));
  const [open, setOpen] = useState(false);
  const [lastValue, setLastValue] = useState(value);
  if (value !== lastValue) { setLastValue(value); setText(isoToFr(value)); }

  const commitText = (t) => {
    setText(t);
    if (!t) { onChange(""); return; }
    const d = parse(t, "dd/MM/yyyy", new Date());
    if (isValid(d) && t.length === 10) onChange(format(d, "yyyy-MM-dd"));
  };

  return (
    <div className={`flex items-center gap-1 ${className}`}>
      <Input
        value={text}
        required={required}
        placeholder={placeholder}
        inputMode="numeric"
        maxLength={10}
        onChange={(e) => commitText(e.target.value.replace(/[^\d/]/g, "").replace(/^(\d{2})(\d)/, "$1/$2").replace(/^(\d{2}\/\d{2})(\d)/, "$1/$2"))}
        onBlur={() => setText(isoToFr(value))}
        data-testid={testId}
        className="font-mono"
      />
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button type="button" variant="outline" size="icon" className="shrink-0 text-[#003087]" aria-label="Ouvrir le calendrier" data-testid={testId ? `${testId}-calendar-btn` : undefined}>
            <CalendarDays className="h-4 w-4" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0" align="start">
          <Calendar
            mode="single"
            locale={fr}
            weekStartsOn={1}
            selected={isoToDate(value)}
            defaultMonth={isoToDate(value)}
            onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }}
            initialFocus
          />
        </PopoverContent>
      </Popover>
      {value && !required && (
        <Button type="button" variant="ghost" size="icon" className="shrink-0 text-gray-400" onClick={() => onChange("")} aria-label="Effacer">
          <X className="h-4 w-4" />
        </Button>
      )}
    </div>
  );
};
